export default __webpack_public_path__ + "static/media/Logo-ECDConnect.9a687cff.svg";